// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__5POCi","wrapper":"Error404_wrapper__HEoL9"};